import { post, get, burn } from './request'
import { utilities } from '@billow/js-helpers'

export default {
  signup: (payload, success, failure) => post('/api/signup', payload, success, failure),
  logout: (success, failure) => post('/logout', {}, success, failure),
  authenticate: (user, success, failure) => post('/login', user, success, failure),
  loadAuthUser: (success, failure) => get('/api/user', success, failure),
  loadAccount: (success, failure) => get('/api/account', success, failure),
  loadPlans: (success, failure) => get('/api/plans', success, failure),
  loadCard: (success, failure) => get('/api/card', success, failure),
  loadApiKeys: (success, failure) => get('/api/api-keys', success, failure),
  signedStorageUrl: (success, failure) => post('/api/signed-storage-url', {}, success, failure),
  updateAccount: (payload, success, failure) => post('/api/account', payload, success, failure),
  updateProfile: (payload, success, failure) => post('/api/profile', payload, success, failure),
  loadAccountOverview: (success, failure) => get('/api/account/overview', success, failure),
  uploadProfilePicture: (payload, success, failure) => post(
    `/api/profile-picture`,
    utilities.formData(payload),
    response => success(response),
    error => failure(error)
  ),
  subscribeToPlan: (payload, success, failure) => post('/api/subscribe', payload, success, failure),
  get2FaQrCode: (success, failure) => get('/user/two-factor-qr-code', success, failure),
  get2FaRecoveryCodes: (success, failure) => get('/user/two-factor-recovery-codes', success, failure),
  send2FaChallenge: (payload, success, failure) => post('/two-factor-challenge', payload, success, failure),
  finalise2FaSetup: (payload, success, failure) => post('/api/two-factor-setup', payload, success, failure),
  enable2Fa: (success, failure) => post('/user/two-factor-authentication', {}, success, failure),
  disable2Fa: (success, failure) => burn('/api/two-factor-authentication', {}, success, failure),
  loadLatestInvoices: (success, failure) => get('/api/latest-invoices', success, failure),
}
